const Colors = {
    PRIMARY_ORANGE: '#ff673d',
    SECONDARY_ORANGE: '#ffa04d',
    BACKGROUND: '#ff673d',  //'#1a1b1f',
    POP:'#ff673d',
    APP_BAR: '#15191a'
};

export default Colors;